<template>
  <div>
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
const default_layout = "default";
// const default_title = ;
export default {
  data() {
    return {
      default_title: this.$t("front_end.common.default_title")
    };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        let debug =
          process.env.NODE_ENV == "development" ? this.$route.name + " - " : "";
        document.title = debug + this.$t(to.meta.title) || this.default_title;
      }
    }
  },
  methods: {
    focusElement: function(isNext = 1) {
      //add all elements we want to include in our selection
      var focussableElements =
        'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]),  input[type=number]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
      if (document.activeElement && document.activeElement.form) {
        var focussable = Array.prototype.filter.call(
          document.activeElement.form.querySelectorAll(focussableElements),
          function(element) {
            //check for visibility while always include the current activeElement
            return (
              element.offsetWidth > 0 ||
              element.offsetHeight > 0 ||
              element === document.activeElement
            );
          }
        );
        var index = focussable.indexOf(document.activeElement);
        if (index > -1 && isNext === 1) {
          var nextElement = focussable[index + 1] || focussable[0];
          nextElement.focus();
        }
        if (isNext === -1 && index - 1 >= 0) {
          var prevElement = focussable[index - 1] || focussable[0];
          prevElement.focus();
        }
      }
    }
  },
  mounted() {
    const self = this;
    document.addEventListener("input", function(e) {
      var target = e.srcElement || e.target;

      if (target.classList.contains("auto-next")) {
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          self.focusElement(1);
        } else if (myLength === 0 && e.keyCode !== 9) {
          // self.focusElement(-1);
        }
      }
    });
    document.addEventListener("input", function(e) {
      var target = e.srcElement || e.target;
      if (target.attributes["maxlength"]) {
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;
        if (myLength >= maxLength) {
          target.value = target.value.substr(0, maxLength);
        }
      }
    });
  }
};
</script>
<style lang="scss">
$loaderColor: #dd0017;
$loaderBackground: #dadada;
@import "~vue-loading-overlay/src/scss/index.scss";
</style>
